<template>
  <section
    class="page-container"
    :class="{'page-container__sme':isSme}">
    <h1>{{isSme||isSmeRefer?'Select Customer':'Attach Customer'}}</h1>
    <div class="btn-top-container">
      <v-button
        type="primary"
        @click="handlerCreateAccount">Create Account</v-button>
      <v-button @click="() => $router.back()">Previous</v-button>
      <v-button
        type="primary"
        :disabled="selectRow === ''"
        @click="handlerNext">Next</v-button>
    </div>
    <div
      v-if="isSme"
      class="sme-container__content">
      <div class="flex-sb-center">
        <div class="flex-column">
          <span class="dollar__title">Estimated Premium</span>
          <span class="blue fs-24 font-inter">${{estimatedPremium}}</span>
        </div>
        <span>
          <v-button
            type="plain"
            @click="handleDownloadPdf">Download PDF</v-button>
        </span>
      </div>
    </div>
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        :prefixIcon="'el-icon-search'"
        placeholder="ID, Name, Registered Login, Contact, Phone or Email"
        @keyEnter="filterData"
      />
    </div>

    <div class="filter-container">
      <!--      <div>-->
      <div class="filter-left-container">
        <div class="type-button">
          <div class="filter-box-text">
            <span>Type</span>
            <span class="flex ">
              <span @click="handlerFilter('type','list')">All</span>
              <span @click="handlerClearFilter('type')">None</span>
            </span>
          </div>
          <v-checkbox-group
            v-model="type"
            :borderBlock="true"
            :list="list"
            @change="filterData"
          />
        </div>
        <div class="status-button">
          <div class="filter-box-text">
            <span>Status</span>
            <span class="flex ">
              <span @click="handlerFilter('status','statusOption')">All</span>
              <span @click="handlerClearFilter('status')">None</span>
            </span>
          </div>
          <v-checkbox-group
            v-model="status"
            :borderBlock="true"
            :list="statusOption"
            @change="filterData"
          />
        </div>
        <div class="filter-box">
          <div class="filter-box-text">
            <span>Tags</span>
            <span class="flex ">
              <span @click="handlerFilter('tags')">All</span>
              <span @click="handlerClearFilter('tags')">None</span>
            </span>
          </div>
          <div class="flex">
            <v-checkbox
              v-model="referralRequestStts"
              :isBoolean="false"
              class="span-status"
              @change="filterData"
            >Need Approval</v-checkbox
            >
            <v-checkbox
              v-model="uploadRequestStts"
              :isBoolean="false"
              class="upload-status"
              @change="filterData"
            >Unread Upload</v-checkbox
            >
            <v-checkbox
              v-model="is_blocked"
              :isBoolean="false"
              class="blocked-status"
              @change="filterData"
            >Blocked</v-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        :header-row-class-name="'tableHeader'"
        style="width: 100%"
        @row-click="rowClick"
      >
        <el-table-column
          width="55">
          <template slot-scope="scope">
            <span :class="[scope.row.checked? 'radio-circle-checked': 'radio-circle' ]"></span>
            <!-- <span>{{ scope.row.checked }}</span> -->
            <!-- <el-radio v-model="tableRadio[scope.$index].checked"/> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          width="35"
        >
          <template>
            <font-awesome-icon icon="user"></font-awesome-icon>
          </template>
        </el-table-column>
        <el-table-column
          label="Type"
          width="100">
          <template slot-scope="scope">
            <span  class="span-status type-status">{{ scope.row.identity_language }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="isrd_nm"
          width="220"
          :show-overflow-tooltip="true"
          label="Name">
          <template slot-scope="scope">
            <span
              v-if="scope.row.is_top_data"
              class="green_tip block">Potential Match</span>
            <span
              v-if="scope.row.is_green_tip"
              class="green_tip">{{scope.row.green_tip}}</span>
            <span
              class="showLick"
              :class="{'unname' : scope.row.isrd_nm == ' '}">
              {{ scope.row.isrd_nm != ' '? scope.row.isrd_nm : 'Unnamed Account'}}
            </span>
            <p class="liter-text">#{{ scope.row.id }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="registered_login"
          width="300"
          label="Registered Login & Contact"
        >
          <template slot-scope="scope">
            <span
              class="login-text"
              :class="{'color-purple':scope.row.attached_account}">{{ scope.row.registered_login }}</span>
            <p
              v-if="scope.row.identity==2"
              class="liter-text">{{ scope.row.contact_nm }} {{ scope.row.contact_phone}} {{scope.row.contact_email}}</p>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="contact_nm"-->
        <!--          label="Contact (Company)"-->
        <!--        ></el-table-column>-->
        <!--        <el-table-column-->
        <!--          prop="contact_phone"-->
        <!--          label="Phone (Company)"-->
        <!--        ></el-table-column>-->
        <el-table-column
          prop="policy_num"
          label="Policy"
        ></el-table-column>
        <el-table-column
          label="Status"
          width="190"
        >
          <template #default="{ row }">
            <div class="flex">
              <span
                class="span-status"
                :class="{
                  'success': row.status == 1,
                  'warning': row.status == 2,
                  'error': row.status == 0
                }">{{ row.status_language }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Tags"
          width="190"
        >
          <template #default="{ row }">
            <div class="flex">
              <span
                v-if="row.referral_request_stts == 0"
                class="span-status warning-plain">Need Approval</span>
              <span
                v-if="row.upload_request_stts == 1"
                class="span-status unread-uplod">Unread Upload</span>
            </div>
            <div
              v-if="row.is_blocked"
              class="flex tags">
              <span
                class="span-status blocked-status">Blocked</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column  label="">
          <template slot-scope="scope">
            <v-button
              type="text"
              :stop="true"
              @click="handlerView(scope.row)">View</v-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />

    <v-dialog
      v-model="createAccountDialog"
      width="962px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h1>Create Customer Account</h1>
        </div>
        <div class="dialog-content flex">
          <div class="left">
            <account-form
              ref="base-info"
              @getFormData="getSubFormData"/>
          </div>
          <div class="right">
            <address-form
              ref="address-info"
              :isRules="false"
              @getFormData="getSubFormData"/>
          </div>
        </div>
        <div class="dialog-footer">
          <div>
            <v-button @click="createAccountDialog = false">Cancel</v-button>
          </div>
          <div>
            <v-button
              type="primary"
              @click="handlerCreate">Create And Attach</v-button>
          </div>
        </div>
      </div>
    </v-dialog>
    <send-email-sms
      ref="send-form"
      :form="customerData"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      :updateContent="true"
      @send="handlerEmailSmsSend"
      @skip="handlerEmailSmsSkip" ></send-email-sms>
  </section>
</template>

<script>
import AccountForm from '../accounts/components/form/account-form'
import AddressForm from '@/views/components/address-form'
import {createAccount, getCustomerList} from '@/api/account'
import {mapActions, mapState} from 'vuex'
import {saveQuotation} from '@api/quote'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'
import MixinSMERefer from '@/mixins/smeRefer'
import sendEmailSms from '@/views/components/dialogs/send-email-sms'
import {shareGuestAddCustomer} from '@/api/share'

export default {
  name: 'Accounts',
  components: {
    AccountForm,
    AddressForm,
    sendEmailSms
  },
  mixins: [MixinOptions,MixinSMERefer,MinxinFormat],
  props:{
    isNewSME:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      selectRow: '',
      createAccountDialog: false,
      type: [],
      search: '',
      tableData: [],
      status: [],
      referralRequestStts: 0,
      uploadRequestStts: 0,
      is_blocked:0,
      subForm: {
        'base-info': false,
        'address-info': false
      },
      customerFormData: {},
      filterList: [
        {
          name: 'Personal',
          id: 1
        },
        {
          name: 'Company',
          id: 2
        }
      ],
      filterSMEList: [
        {
          name: 'Company',
          id: 2
        }
      ],
      filter:{}
    }
  },
  computed: {
    ...mapState('quote', ['code']),
    ...mapState('coupon', ['selectCode']),
    isSme(){
      let {productType} = this.$route.params
      return productType == 'sme'
    },
    isSmeRefer(){
      let {productType} = this.$route.params
      return productType == 'refer'
    },
    list(){
      let arr = this.filterList
      if([13,14,16,18,21,22].includes(Number(this.productId))){
        arr = [ {
          name: 'Personal',
          id: 1
        },]
      }
      if([15].includes(Number(this.productId))||this.isSme||this.isSmeRefer||this.isNewSME){
        arr = [ {
          name: 'Company',
          id: 2
        }]
      }
      return arr
    },

    orderId(){
      return this.$route.query.order_id
    }
  },
  created() {
    // this.tableData.map((item, index) => {
    //   item.checked = false
    //   item.index = index
    //   return item
    // })
    // this.tableData = JSON.parse(JSON.stringify(this.tableData))
    this.filter =  this.$route.query.filterData
    // 根據 product id 來默認篩選 公司 or 個人
    if([11, 17,20].includes(Number(this.productId))) {
      this.type = [1, 2]
    }
    else if([12, 13, 14, 16, 18, 19,21,22].includes(Number(this.productId))) {
      this.type = [1]
    }
    else {
      this.type = [2]
    }
    if(this.isSme||this.isSmeRefer||this.isNewSME){
      this.type = [2]
    }
    this.network().getCustomerList()
  },
  methods: {
    ...mapActions('account', ['setCustomerId','setSelectCustomerData']),
    ...mapActions('quote', ['setQuoteForm']),
    handlerView({ id }) {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: id
        }
      })
    },
    handlerFilter(name,option){
      if(name=='tags')
      {
        this.referralRequestStts=1
        this.uploadRequestStts=1
        this.is_blocked=1
      }
      else
      {
        const data = this[option].reduce((result, item) => {
          result.push(item.id)
          return result
        }, [])
        this[name] = data
      }
      this.filterData()
    },
    handlerClearFilter(name){
      this[name] = []
      if(name=='tags')
      {
        this.referralRequestStts=0
        this.uploadRequestStts=0
        this.is_blocked=0
      }
      this.filterData()
    },
    rowClick(row) {
      const { index } = row
      this.tableData.map(item => {
        item.checked = false
      })
      this.tableData[index].checked = true
      this.selectRow = index
      if(this.isSme){
        this.setCustomerId(this.tableData[this.selectRow].id)
      }
      //   this.$router.push('/accounts/detail')
    },
    handlerCreate() {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if(Object.values(this.subForm).some(item => item === false)) {
        return
      }
      this.network().createAccount()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getCustomerList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCustomerList()
    },
    handlerNext() {
      if(this.selectRow === '') {
        this.$message({
          type: 'warning',
          message: '請先選擇用戶'
        })
        return
      }
      // 存在order id的是share guest 如果是share guest则调用share的addcustomer，然后返回quote
      if(this.orderId){
        let params = {
          order_id: this.orderId,
          customer_id: this.tableData[this.selectRow].id
        }
        this.network().shareGuestAddCustomer(params)
        return
      }
      this.setSelectCustomerData(this.tableData[this.selectRow])
      this.setCustomerId(this.tableData[this.selectRow].id)
      // this.setQuoteForm(null)
      // this.$router.push('/quoting/underwriting')
      // 調取保存報價接口
      if(this.isSme){
        this.handleSmeNext()
      }
      else if(this.isSmeRefer){
        this.getAccountDetail()
      }
      else
      {
        // let {referrer_code} = this.tableData[this.selectRow]||{}
        let params = JSON.parse(this.$route.query.data)
        // params.code = referrer_code
        this.network().saveQuotation(params)
      }
    },
    handlerCreateAccount() {
      this.createAccountDialog = true
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.customerFormData = Object.assign(this.customerFormData, data)
    },
    network() {
      return {
        getCustomerList: async () => {
          let { data } = await getCustomerList({
            type: this.type,
            search: this.search,
            page: this.pageConfig.currentPage,
            status: this.status,
            referral_request_stts: this.referralRequestStts,
            upload_request_stts:this.uploadRequestStts,
            is_blocked:this.is_blocked,
            order_id: this.orderId
          })
          data.data.map((item, index) => {
            item.checked = false
            item.index = index
            return item
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          if(this.customerId){
            let index =  this.tableData.findIndex(item=>item.id==this.customerId)
            this.selectRow = index
            this.tableData[index].checked = true
          }
          // this.pageConfig.pageSize = data.per_page
        },
        createAccount: async () => {
          const { data } = await createAccount(this.customerFormData)
          // this.customerId = data.id
          this.setCustomerId(data.id)
          this.createAccountDialog = false
          if(this.isSme){
            this.handleSmeNext()
          }
          else if(this.isSmeRefer){
            this.getAccountDetail()
          }else
            this.network().saveQuotation(JSON.parse(this.$route.query.data))

          // this.$router.push('/quoting/underwriting')
        },
        saveQuotation: async (params) => {
          // const { trm_of_cvr = [], isrd_vl } =filterData
          params.isrd_vl =  this.filter
          let {coupon,code,is_campaign_code} = this.selectCode||{}
          if(coupon&&coupon.selectCode==1)
            params.coupon_code = coupon&&coupon.coupon_code
          if(code&&code.selectCode==2){
            params.code = code&&code.code
          }
          if(is_campaign_code){
            params.campaign_code = code&&code.code
            delete params.code
          }
          const { data } = await saveQuotation({
            ...params,
            customer_id: this.customerId,
            // code: this.code
          })

          if(data.code == 4179){
            this.$router.push({
              name: 'quotingRefer',
              query: {
                product_id: this.productId
              }
            })
            return
          }
          const { order_id, quo_id } = data.data
          this.$router.push({
            path: '/quoting/information',
            query: {
              order_id,
              quo_id,
              product_id: this.productId
            }
          })
        },

        shareGuestAddCustomer: async (params) => {
          const {data} = await shareGuestAddCustomer(params)
          this.setSelectCustomerData(this.tableData[this.selectRow])
          this.setCustomerId(this.tableData[this.selectRow].id)
          const {code} = data
          if(code == 1000){
            this.$router.push({
              name: 'quotingQuote',
              query: {
                product_id: this.productId,
                order_id: this.orderId
              }
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  &.page-container__sme{
    margin: -20px;
    padding: 30px 70px;
    background: #fff;
    .btn-top-container{
      top: 30px;
      right: 70px;
    }
    .sme-container__content{
      padding: 15px;
      background: $gray;
      margin-bottom: 30px;
      border-radius: 6px;
      .flex-column{
        display: flex;
        flex-direction: column;
        .dollar__title{
          color: $dark;
          font-size: 16px;
          font-weight: 600;
          font-family: $fontText;
        }
        .fs-24{
          font-size: 24px;
          font-family: $fontText;
        }
      }

    }
  }

  h1 {
    margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    display: flex;
    align-items: center;
    margin: 0 auto 20px 0;
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }
    .filter-checkbox {
      margin: 0 20px;
    }
    .input-container {
      width: 360px;
    }
  }
  .dialog-container {
      color: #616266;
      .dialog-header {
          padding: 15px;
          h1 {
              margin: 0;
              font-size: 24px;
          }
      }
      .dialog-content {
          justify-content: space-between;
          padding: 15px;
          border-top: 1px solid #DDDFE7;
          border-bottom: 1px solid #DDDFE7;
          & > div {
              width: calc(50% - 10px);
              &:first-child {
                  padding-right: 20px;
                  border-right: 1px solid #DDDFE7;
              }
          }
      }
      .dialog-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px;
      }
  }
  .span-status {
    display: block;
    margin-right: 5px;
    padding: 0 10px;
    height:  20px;
    line-height: 20px;
    border-radius: 25px;
    font-size: 12px;
    white-space: nowrap;
    &.blocked-status{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #CB2431;
      color: #D73A49;
    }
    &.success {
      color:  rgb(67, 181, 92);
      background: rgb(220, 255, 228);
    }
    &.warning {
      background: rgb(255, 245, 177);
      color: rgb(218, 193, 93);
    }
    &.error {
      background: rgb(215, 58, 73);
      color: white;
    }
    &.warning-plain {
      border: 1px solid #B08800;
      color: #B08800;
    }
    &.unread-uplod {
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.type-status{
      border: 1px solid #E1E4E8;
      color: #24292E;
    }
  }
  .filter-top{
    margin-bottom: 30px;
  }
  .filter-container {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    padding: 16px;
    //justify-content: space-between;
    .filter-box-text{
      display: flex;
      margin-bottom: 12px;
      /*justify-content: space-between;*/
      margin-right: 20px;
      span{
        margin-right: 10px;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      span:first-child{
        color: #24292E;
        font-weight: 600;

      }
      .flex{
        span{
          color: #0366D6;
          cursor: pointer;
        }
      }
    }
    .filter-left-container {
      display: flex;
      align-items: center;
    }
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }

    .filter-checkbox {
      margin: 0 20px;
    }

    .input-container {
      max-width: 360px;
    }
    .button-right {
      // position: absolute;
      // right: 0;
      margin-left: 20px;
    }

    .filter-box {
      margin-right: 20px;
      .span-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #b08800;
          color: #b08800;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
      .upload-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #0366D6;
          color: #0366D6;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
      .blocked-status{
        display: flex;
        align-items: center;
        margin-right: 5px;
        padding: 0 10px;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          background: #FFFFFF;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
          border: 1px solid #CB2431;
          color: #D73A49;
        }
      }
    }
    .status-button {
      // margin-right: 20px;
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              border: 0;
              border-radius: 50px;
            }
          }
          &:nth-child(3) {
            .el-checkbox__label {
              span {
                background: rgb(215, 58, 73);
                color: white;
              }
            }
          }
          // &:last-child {
          //    .el-checkbox__label{
          //     span{
          //       border:1px solid #B08800;
          //       color: #B08800;
          //       background: white;
          //     }
          //   }
          // }
          &:first-child {
            .el-checkbox__label {
              span {
                background: rgb(220, 255, 228);
                color: rgb(67, 181, 92);
              }
            }
          }
          &:nth-child(2) {
            .el-checkbox__label {
              span {
                background: rgb(255, 245, 177);
                color: rgb(218, 193, 93);
              }
            }
          }
        }
      }
    }
    .type-button {
      // margin-right: 20px;
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              border-radius: 50px;
              border: 1px solid #E1E4E8;
              color: #24292E;
              background: white;
              font-weight: 500;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
        }
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: nowrap;
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    .el-table__header{
      overflow: hidden;

    }
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
  .flex-aglin{
    align-items: center;
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
    .login-text{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
    }
  }
  ::v-deep .el-checkbox-group{
    .el-checkbox__label span{
      line-height: 20px;
    }
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #D5D8DE;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .showLick{
    color:  #000;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .unname{
    font-style: italic;
    color: #6A737D;
  }
  .green_tip{
    color: rgb(67, 181, 92);
  }

  .block{
    display: block;
  }
}
</style>
